import type { MediaModel } from "@src/utils/components/dropzone";
import { required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";
import { compact } from "lodash";

export class FormOtherDocument {
  title = new FieldState("").validators(required);
  related_to = new FieldState("").validators(required);
  brand_id = new FieldState("").validators();
  client_id = new FieldState("").validators();
  contractor_id = new FieldState("").validators();
  files = new FieldState<MediaModel[]>([]).validators();
  project_ids = new FieldState<string[]>([]).validators();
  form = new FormState({
    title: this.title,
    brand_id: this.brand_id,
    related_to: this.related_to,
    client_id: this.client_id,
    contractor_id: this.contractor_id,
    files: this.files,
    project_ids: this.project_ids,
  });

  validate = async () => {
    const res = await this.form.validate();

    return res.hasError ? null : this.serialize();
  };

  serialize() {
    return {
      title: this.title.$,
      brand_id: this.brand_id.$ || undefined,
      client_id: this.client_id.$ || undefined,
      contractor_id: this.contractor_id.$ || undefined,
      files: compact(this.files.$.map((f) => f.isFile && f._file)),
      project_ids: this.project_ids.$,
    };
  }
}

export type IFormOtherDocumentSerialized = ReturnType<
  FormOtherDocument["serialize"]
>;
